
var stache = require('can/view/stache/stache');
module.exports = stache("<div class=\"c-instagram-embed\">\r\n\r\n</div>");